
const extractStreetAdresss = (address): string => {

  let streetAddress = {addressLine: address.flat_unit};

  appendAddressElement(streetAddress, address.floor_level);
  appendAddressElement(streetAddress, address.house_number);
  appendAddressElement(streetAddress, buildLotNumber(address.lot_nbr));
  appendAddressElement(streetAddress, address.street);

  return streetAddress.addressLine;
}

const buildLotNumber = (lotNumber: string): string => {
  let modifiedLotNumber = "";
  if (lotNumber && lotNumber.length > 0) {
    modifiedLotNumber = "Lot " + lotNumber;
  }

  return modifiedLotNumber;
}

const extractBuildingName = (address): string => {

  let fullBuildingName = {addressLine: ""};

  if (address.building_property_name_1) {
    address.building_property_name_1.forEach(buildingName => appendAddressElement(fullBuildingName, buildingName))
  }

  return fullBuildingName.addressLine;
}

export const appendAddressElement = (address: {addressLine: string}, element: string) => {
  if (!element || element.trim().length == 0) {
    return;
  }

  let separator = "";
  let baseAddress = address.addressLine ? address.addressLine.trim() : "";
  if (baseAddress.length > 0) {
    separator = " ";
  }

  address.addressLine = baseAddress + separator + element;
}
